var $imports = require("../../../../../node_modules/art-template/lib/runtime.js");
module.exports = function ($data) {
    'use strict';
    $data = $data || {};
    var $$out = '', $escape = $imports.$escape, customerService = $data.customerService, about = $data.about, openMember = $data.openMember, exchangeMember = $data.exchangeMember;
    $$out += '    <paddle exclude-devices="tablet" name="fv--fw-help-tab-paddle">\n        <group-list name="convert-toolbar-group-list">\n            <group name="convert-tab-group-hand" retain-count="2">\n                <xbutton\n                  class="convert-item"\n                  name="hand-tool"\n                  @tooltip tooltip-title="手型工具"\n                  text=""\n                  icon-class="fv__icon-toolbar-hand"\n                  @controller="states:HandController">\n                </xbutton>\n                <div class="text-none text-have-more">\n                                <selection-ribbon-dropdown icon-class="fv__icon-toolbar-select"></selection-ribbon-dropdown>\n                            </div>\n                            <!-- <fw-module:fw-selection-button></fw-module:fw-selection-button> -->\n            </group>\n            <group name="convert-tab-group-to-file" retain-count="5">\n                <ribbon-button class="convert-item fv__ui-toolbar-show-text-button" name=';
    $$out += $escape(customerService.name);
    $$out += ' @tooltip tooltip-title=';
    $$out += $escape(customerService.title);
    $$out += ' icon-class=';
    $$out += $escape(customerService.icon);
    $$out += ' text=';
    $$out += $escape(customerService.title);
    $$out += '>';
    $$out += $escape(customerService.title);
    $$out += '</ribbon-button>\n                <ribbon-button class="convert-item fv__ui-toolbar-show-text-button" name=';
    $$out += $escape(about.name);
    $$out += ' @tooltip tooltip-title=';
    $$out += $escape(about.title);
    $$out += ' icon-class=';
    $$out += $escape(about.icon);
    $$out += ' text=';
    $$out += $escape(about.title);
    $$out += '>';
    $$out += $escape(about.title);
    $$out += '</ribbon-button>\n                <ribbon-button class="convert-item fv__ui-toolbar-show-text-button" name=';
    $$out += $escape(openMember.name);
    $$out += ' @tooltip tooltip-title=';
    $$out += $escape(openMember.title);
    $$out += ' icon-class=';
    $$out += $escape(openMember.icon);
    $$out += ' text=';
    $$out += $escape(openMember.title);
    $$out += '>';
    $$out += $escape(openMember.title);
    $$out += '</ribbon-button>\n                <ribbon-button class="convert-item fv__ui-toolbar-show-text-button" name=';
    $$out += $escape(exchangeMember.name);
    $$out += ' @tooltip tooltip-title=';
    $$out += $escape(exchangeMember.title);
    $$out += ' icon-class=';
    $$out += $escape(exchangeMember.icon);
    $$out += ' text=';
    $$out += $escape(exchangeMember.title);
    $$out += '>';
    $$out += $escape(exchangeMember.title);
    $$out += '</ribbon-button>\n            </group>\n        </group-list>\n    </paddle>\n';
    return $$out;
};